import PropTypes from 'prop-types';
import { multipleComponentIterator } from './MultipleComponentIterator.utils';
import { ObjectPropsPropType } from '../../../../services/proptypes';
import { ComponentPropType } from '../../types/component';
export function multipleComponentIterationConfig() {
  return PropTypes.shape({
    component: ComponentPropType.isRequired,
    propMap: PropTypes.shape({}),
    children: PropTypes.arrayOf(multipleComponentIterationConfig)
  });
}
var propTypes = {
  iterator: PropTypes.oneOfType([PropTypes.arrayOf(ObjectPropsPropType), ObjectPropsPropType]).isRequired,
  components: PropTypes.arrayOf(multipleComponentIterationConfig()).isRequired,
  limit: PropTypes.number,
  start: PropTypes.number
};
var defaultProps = {
  limit: null,
  start: null
};
export default function MultipleComponentIterator(_ref) {
  var iterator = _ref.iterator,
    components = _ref.components,
    limit = _ref.limit,
    start = _ref.start;
  return multipleComponentIterator({
    iterator: iterator,
    components: components,
    limit: limit,
    start: start
  });
}
MultipleComponentIterator.propTypes = propTypes;
MultipleComponentIterator.defaultProps = defaultProps;